import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SearchSelect from "components/common/SearchSelect";
import { fetchCities } from "api/menu/master-files/locations/actions";

const SelectCity = ({
                            isClearable,
                            isMultiple,
                            onBlur,
                            provinceId,
                            value,
                            onChange,
                            fetchCities,
                        }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (provinceId) {
            fetchCities(provinceId, (cities) => {
                setOptions(cities.map(value => ({
                    value: value.id,
                    label: value.name
                })));
            });
        } else {
            setOptions([]);
        }
    }, [fetchCities, provinceId]);

    let currentValue = options.find(item => item.value === value) || null;
    if (value === null) {
        currentValue = isMultiple ? [] : null;
    } else if (Array.isArray(value)) {
        currentValue = options.filter(item => value.indexOf(item.value) > -1);
    } else if (value) {
        currentValue = options.find(item => value === item.value);
    }

    return (
        <SearchSelect
            className="custom-react-select"
            isLoading={false}
            isClearable={isClearable}
            isSearchable={true}
            isMulti={isMultiple}
            onBlur={onBlur}
            options={options}
            value={currentValue}
            onChange={items => {
                if (!items) {
                    onChange(isMultiple ? [] : null);
                } else {
                    onChange(items);
                }
            }}
        />
    );
};

const mapStateToDispatch = dispatch => ({
    fetchCities: bindActionCreators(fetchCities, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(SelectCity);
